import React, { useState, useEffect } from "react";
import logo from '../images/logo/mainlogo.png';

const InquiryFormPopup = () => {
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowForm(true);
    }, 20000); // Show form after 30 seconds

    return () => clearTimeout(timer);
  }, []);

  const handleCloseForm = () => {
    setShowForm(false);
  };

  return (
    <>
      {showForm && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999, // Ensures popup is on top of all elements
            padding: "10px",
          }}
        >
          <div
            style={{
              backgroundColor: "rgba(255, 255, 255, 0.15)", // Semi-transparent white background
              padding: "20px",
              borderRadius: "12px",
              width: "100%",
              maxWidth: "400px",
              boxSizing: "border-box",
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
              position: "relative",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              backdropFilter: "blur(10px)", // Blur effect for glassmorphism
              border: "1px solid rgba(255, 255, 255, 0.3)", // Subtle border for glass effect
            }}
          >
            <button
              onClick={handleCloseForm}
              style={{
                backgroundColor: "red",
                color: "white",
                border: "none",
                padding: "8px",
                borderRadius: "4px",
                cursor: "pointer",
                position: "absolute",
                top: "10px",
                right: "10px",
              }}
            >
              Close
            </button>
            <h2 style={{ textAlign: "center", fontSize: "1.5rem", margin: "10px 0", color: "#fff" }}>
              Inquiry Form
            </h2>
            <img 
              src={logo} 
              alt="Logo" 
              style={{ margin: "10px 0" }} 
              width={100} 
              height="auto" 
            />
            <form style={{ display: "flex", flexDirection: "column", gap: "10px", width: "100%" }}>
              <label style={{ fontSize: "1rem", color: "#fff" }}>
                Name:
                <input
                  type="text"
                  name="name"
                  style={{
                    width: "100%",
                    padding: "10px",
                    marginTop: "5px",
                    borderRadius: "4px",
                    border: "1px solid rgba(255, 255, 255, 0.3)",
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    color: "#fff",
                    boxSizing: "border-box",
                  }}
                />
              </label>
              <label style={{ fontSize: "1rem", color: "#fff" }}>
                Phone:
                <input
                  type="text"
                  name="name"
                  style={{
                    width: "100%",
                    padding: "10px",
                    marginTop: "5px",
                    borderRadius: "4px",
                    border: "1px solid rgba(255, 255, 255, 0.3)",
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    color: "#fff",
                    boxSizing: "border-box",
                  }}
                />
              </label>
              <label style={{ fontSize: "1rem", color: "#fff" }}>
                Email:
                <input
                  type="email"
                  name="email"
                  style={{
                    width: "100%",
                    padding: "10px",
                    marginTop: "5px",
                    borderRadius: "4px",
                    border: "1px solid rgba(255, 255, 255, 0.3)",
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    color: "#fff",
                    boxSizing: "border-box",
                  }}
                />
              </label>
              <label style={{ fontSize: "1rem", color: "#fff" }}>
                Message:
                <textarea
                  name="message"
                  style={{
                    width: "100%",
                    padding: "10px",
                    marginTop: "5px",
                    borderRadius: "4px",
                    border: "1px solid rgba(255, 255, 255, 0.3)",
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    color: "#fff",
                    boxSizing: "border-box",
                    resize: "vertical",
                    minHeight: "80px",
                  }}
                ></textarea>
              </label>
              <button
                type="submit"
                style={{
                  padding: "12px",
                  marginTop: "10px",
                  borderRadius: "4px",
                  border: "none",
                  backgroundColor: "#007BFF",
                  color: "white",
                  fontSize: "1rem",
                  cursor: "pointer",
                }}
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default InquiryFormPopup;
